module.exports = __webpack_public_path__ + "static/media/logo_white1.29c8926b.png";